import { db } from '../../firebase'

export const Announcements = db.collection('announcements')

export const getFeaturedAnnouncements = () => Announcements.where('featured', '==', true)
